<template>
  <div class="loader">
    <span :class="bounceClasses"></span>
    <span :class="bounceClasses"></span>
    <span :class="bounceClasses"></span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bounceClasses () {
      return {
        'bounce': true,
        'dark': this.dark
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1.0);
  }
}

.loader {
  padding: 26px 37px;
}

.bounce {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 100%;
  display: inline-block;
  animation: bounce 1400ms infinite ease-in-out both;

  &:first-child {
    animation-delay: -320ms;
  }

  &:nth-child(2) {
    animation-delay: -160ms;
  }
}

.dark {
  background-color: $c-blue;
}
</style>
